import {Skeleton} from '@chekin/guestapp-ui-kit';

export const PaymentFormSkeleton = () => {
  return (
    <div className="flex flex-col w-full space-y-8 absolute">
      <Skeleton className="h-[60px] mb-5" />
      <Skeleton className="h-[35px] mx-7 rounded" />
      <Skeleton className="h-[35px] mx-7 rounded" />
      <Skeleton className="h-[35px] mx-7 rounded" />
      <Skeleton className="h-[35px] mx-7 !mb-9 rounded" />
      <Skeleton className="h-[50px] mx-3 rounded" />
      <div className="flex justify-between mx-3 pb-3">
        <Skeleton className="h-[30px] w-[100px] rounded" />
        <Skeleton className="h-[30px] w-[227px] rounded" />
      </div>
    </div>
  );
};
